import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../../services/api';
import logo from '../../assets/1Risk-Calibri-Final-1097x400.png';
import './ForgotPassword.css';

const SUPPORT_URL = 'https://accesso.atlassian.net/servicedesk/customer/portal/1340';

const ForgotPasswordForm = () => {
  const [apiName, setApiName] = useState('');
  const [username, setUsername] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const formValid = apiName && username;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    setLoading(true);
    try {
      const response = await authAPI.requestPasswordReset(apiName.toLowerCase(), username);
      if (response.data) {
        setSuccess(true);
      } else {
        setError('Unable to request password reset for user. Please contact your administrator.');
      }
    } catch {
      setError('Unable to request password reset for user. Please contact your administrator.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="forgot-container">
        <div className="forgot-header-bar">
          <img src={logo} alt="1RISK" className="forgot-header-logo" />
          <a href={SUPPORT_URL} target="_blank" rel="noopener noreferrer" className="support-link">
            Support
          </a>
        </div>
        <div className="forgot-content">
          <div className="forgot-card">
            <h1>Success</h1>
            <p>Password reset email sent successfully.</p>
            <Link to="/login" className="forgot-back-link">
              Return to Login
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="forgot-container">
      <div className="forgot-header-bar">
        <img src={logo} alt="1RISK" className="forgot-header-logo" />
        <a href={SUPPORT_URL} target="_blank" rel="noopener noreferrer" className="support-link">
          Support
        </a>
      </div>

      <div className="forgot-content">
        <div className="forgot-card">
          <h1>Forgot Password</h1>
          <p className="forgot-instructions">
            Please enter your API Name and Username to reset your 1RISK password. Instructions will
            be sent to the email address associated with your account.
          </p>

          {error && <div className="alert alert-error">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="apiName">API Name</label>
              <input
                id="apiName"
                type="text"
                value={apiName}
                onChange={(e) => setApiName(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="username">Username</label>
              <input
                id="username"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>

            <div className="forgot-button-row">
              <button
                type="submit"
                className="forgot-submit-button"
                disabled={!formValid || loading}
              >
                {loading ? 'Sending...' : 'Submit'}
              </button>
              <Link to="/login" className="forgot-cancel-button">
                Cancel
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

const ForgotPassword = () => <ForgotPasswordForm />;

export default ForgotPassword;
